export const COMPANIES = [
  {
    id: "tata-electronics",
    name: "Tata Electronics",
    domain: "tataelectronics.com",
    category: "Semiconductor Fabrication",
    investment: "₹91,000 Cr",
    timeline: "Phase 1 · 2026",
    jobs: "20,000+ direct jobs",
    nriImpact:
      "India's first commercial fab anchors a supplier ecosystem of 100+ ancillary units. Engineer and technician housing demand concentrates in TP 1–TP 4 — the same zones open to individual plot buyers today.",
  },
  {
    id: "tata-power",
    name: "Tata Power",
    domain: "tatapower.com",
    category: "Solar & Power Infrastructure",
    investment: "₹3,000 Cr",
    timeline: "300 MW live",
    jobs: "2,500+ direct jobs",
    nriImpact:
      "Round-the-clock green power is the single biggest tenant-attraction lever for the SIR. Reliable utilities translate directly into higher rental yields and faster plot absorption nearby.",
  },
  {
    id: "renew",
    name: "ReNew",
    domain: "renew.com",
    category: "Renewable Manufacturing",
    investment: "₹2,000 Cr",
    timeline: "Facility · 2026",
    jobs: "3,000+ direct jobs",
    nriImpact:
      "Solar cell and module manufacturing inside the region locks in long-term industrial tenancy, giving residential parcels a durable workforce base rather than speculative demand.",
  },
  {
    id: "reliance",
    name: "Reliance Industries",
    domain: "ril.com",
    category: "Renewable Energy & Logistics",
    investment: "₹7,500 Cr",
    timeline: "Announced · 2025",
    jobs: "12,000+ direct jobs",
    nriImpact:
      "Reliance's entry signals blue-chip confidence to global lenders. Large-format land banking by majors historically precedes the steepest leg of plot appreciation in greenfield regions.",
  },
  {
    id: "adani",
    name: "Adani Group",
    domain: "adani.com",
    category: "Logistics & Data Infrastructure",
    investment: "₹5,000 Cr",
    timeline: "Announced · 2025",
    jobs: "8,000+ direct jobs",
    nriImpact:
      "Port-linked logistics parks and edge data facilities extend Dholera's catchment beyond the SIR boundary, lifting commercial land values along the expressway spine.",
  },
  {
    id: "larsen-toubro",
    name: "Larsen & Toubro",
    domain: "larsentoubro.com",
    category: "Trunk Infrastructure EPC",
    investment: "₹4,200 Cr",
    timeline: "Ongoing works",
    jobs: "15,000+ construction jobs",
    nriImpact:
      "L&T is building the very roads, ducts and utilities that make plots shovel-ready. EPC presence de-risks delivery timelines — the core concern of overseas buyers.",
  },
  {
    id: "suzuki",
    name: "Suzuki Motor Gujarat",
    domain: "suzuki.co.in",
    category: "Automotive Manufacturing",
    investment: "₹11,000 Cr",
    timeline: "Expansion · 2027",
    jobs: "25,000+ direct jobs",
    nriImpact:
      "The Hansalpur plant's expansion creates a commuter belt that spills into Dholera's residential sectors — a proven template from the Manesar and Sanand price curves.",
  },
  {
    id: "torrent-power",
    name: "Torrent Power",
    domain: "torrentpower.com",
    category: "Power Distribution",
    investment: "₹1,800 Cr",
    timeline: "Network rollout",
    jobs: "1,500+ direct jobs",
    nriImpact:
      "A private distribution licensee means metro-grade uptime for industries and homes alike — a quiet but decisive factor in tenant quality and resale premiums.",
  },
  {
    id: "waaree",
    name: "Waaree Energies",
    domain: "waaree.com",
    category: "Solar Module Manufacturing",
    investment: "₹2,600 Cr",
    timeline: "Facility · 2026",
    jobs: "4,000+ direct jobs",
    nriImpact:
      "A second module manufacturer beside the 5,000 MW park clusters the solar supply chain in one district — the kind of industrial density that compounds land values.",
  },
  {
    id: "inox-air",
    name: "Inox Air Products",
    domain: "inoxairproducts.com",
    category: "Industrial Gases",
    investment: "₹900 Cr",
    timeline: "Fab support · 2026",
    jobs: "1,200+ direct jobs",
    nriImpact:
      "Specialty-gas plants only co-locate when fab demand is contracted and real. Their presence is an independent confirmation that the semiconductor timeline is holding.",
  },
];

export const HUB_STATS = [
  { value: "₹1.28 L Cr+", label: "Committed investment" },
  { value: "10", label: "Anchor companies" },
  { value: "92,000+", label: "Projected direct jobs" },
  { value: "2026", label: "First fab rollout" },
];
